import API_URLS from "@constants/api.urls";

import { getRequest } from "../baseApi";

export const getUFDetails = parmas => getRequest(API_URLS.ufDetails, parmas);

export const getSystemDesignData = parmas => getRequest(API_URLS.systemDesign, parmas);

export const getDesignData = parmas => getRequest(API_URLS.designData, parmas);
